const CLIPS_INFO = {
  "The Traitors": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Ftraitors-can't-miss-clips.mp4?alt=media&token=50e1f33b-fa4d-4abc-9aa9-4ae28965d5a5#t=0.1",
    topLineText: "Traitorous",
    bottomLineText: "Gameplay",
    textColor: "#FCCC12",
    ratingBadge: "TVMA",
  },
  "Jeopardy!": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fjeopardy-can't-miss-clips.mp4?alt=media&token=159d5c01-574d-404c-8bfb-5acbce103d83#t=0.1",
    topLineText: "",
    bottomLineText: "",
    textColor: "",
    ratingBadge: "TVG",
  },
  "The Office": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fthe-office-can't-miss-clips.mp4?alt=media&token=6e5033cf-b237-477e-a108-ab1ab7cc0b32#t=0.1",
    topLineText: "Fun At",
    bottomLineText: "Dunder Mifflin",
    textColor: "#EF1541",
    ratingBadge: "TV14",
  },
  LOLz: {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fsnl-can't-miss-clips.mp4?alt=media&token=e01ec912-d9b3-40e6-bc89-c968ce4bc456#t=0.1",
    topLineText: "Live From",
    bottomLineText: "New York",
    textColor: "#069DE0",
    ratingBadge: "TV14",
  },
  "Southern Charm": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fsouthern-charm-cant-miss-clips.mp4?alt=media&token=35dfc7fd-ec62-4915-92de-e877ebf0d176#t=0.1",
    topLineText: "The South",
    bottomLineText: "is a Lifestyle",
    textColor: "#05AC3F",
    ratingBadge: "TV14",
  },
  RHOSLC: {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Frhoslc-cant-miss-clips.mp4?alt=media&token=5b8b6db4-7725-4514-9b69-1b3e9efb75f5#t=0.1",
    topLineText: "Salt Lake City",
    bottomLineText: "Antics",
    textColor: "#6E55DC",
    ratingBadge: "TV14",
  },
  "Below Deck Mediterranean": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fbelow-deck-can't-miss-clips.mp4?alt=media&token=f383c387-395d-47d7-9d91-b3796ec7b96f#t=0.1",
    topLineText: "Work Hard",
    bottomLineText: "Play Hard",
    textColor: "#FCCC12",
    ratingBadge: "TV14",
  },
  "Good News": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fgood-news-can't-miss-clips.mp4?alt=media&token=438eb508-30d4-4e20-9731-245b1c8999d9#t=0.1",
    topLineText: "Today's",
    bottomLineText: "Spotlight",
    textColor: "#FF7112",
    ratingBadge: "TVPG",
  },
  "All the Feels": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fall-the-feels-can't-miss-clips.mp4?alt=media&token=5c9b11ef-e874-4115-8b9e-f725afee56f5#t=0.1",
    topLineText: "Justice",
    bottomLineText: "Never Sleeps",
    textColor: "#6E55DC",
    ratingBadge: "TV14",
  },
  "Lunch Break": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fpsych-cant-miss-clips.mp4?alt=media&token=fc43f42f-4210-4d45-956c-47bacbc8b7bd#t=0.1",
    topLineText: "Shawn and Gus",
    bottomLineText: "Investigate",
    textColor: "#05AC3F",
    ratingBadge: "TV14",
  },
  "Watch What Happens Live": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fwwhl-can't-miss-clips.mp4?alt=media&token=8f5709e7-dd02-4f0a-861e-47bd56769016#t=0.1",
    topLineText: "Late Night",
    bottomLineText: "Gossip",
    textColor: "#EF1541",
    ratingBadge: "TV14",
  },
  RHOP: {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Frhop-can't-miss-clips.mp4?alt=media&token=ad4ac593-9bc5-4c18-9dba-86e53de7c3a8#t=0.1",
    topLineText: "Potomac",
    bottomLineText: "Antics",
    textColor: "#EF1541",
    ratingBadge: "TV14",
  },
  "The Tonight Show": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fjimmy-fallon-can't-miss-clips.mp4?alt=media&token=42ba216f-1113-48cd-818d-8c4dbee05ab3#t=0.1",
    topLineText: "Late Night",
    bottomLineText: "With Jimmy",
    textColor: "#FF7112",
    ratingBadge: "TV14",
  },
  "Late Night with Seth Meyers": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fseth-meyers-cant-miss-clips.mp4?alt=media&token=463902df-76b0-4d57-8921-beb128316ac6#t=0.1",
    topLineText: "Late Night",
    bottomLineText: "With Seth",
    textColor: "#FF7112",
    ratingBadge: "TV14",
  },
  "Vanderpump Rules": {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fvanderpump-rules-can't-miss-clips.mp4?alt=media&token=51e6c54c-c768-474d-ad62-67993cdf80c3#t=0.1",
    topLineText: "New Shift",
    bottomLineText: "Same Rules",
    textColor: "#6E55DC",
    ratingBadge: "TV14",
  },
  Housewives: {
    url: "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fdefault-housewives.mp4?alt=media&token=a732014d-a251-4a4d-841d-7fbfc158e4eb#t=0.1",
    topLineText: "Drama",
    bottomLineText: "Unfolds",
    textColor: "#EF1541",
    ratingBadge: "TV14",
  },
};

const NBA_CLIPS = [
  "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FHighlights%2Fnba-highlights-2.mp4?alt=media&token=371ed8d0-bb85-4208-b9e9-91ff0faff22f#t=0.1",
  "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FHighlights%2Fnba-clips-4.mp4?alt=media&token=558be7da-302d-45d2-9130-62021f1bf2f7#t=0.1",
  "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FHighlights%2Fnba-highlights-1.mp4?alt=media&token=824e306f-6b89-4b1b-9fd6-1afae56d696a#t=0.1",
  "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FHighlights%2Fnba-highlights-4.mp4?alt=media&token=690504f1-377b-41a3-ab31-eb053ba011c3#t=0.1",
];

const DEFAULT_CLIPS = [
  "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fdefault-cant-miss-clip.mp4?alt=media&token=d5a91f73-102d-47ae-9b35-dd4c1a848a29#t=0.1",
  "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fthe-office-can't-miss-clips.mp4?alt=media&token=6e5033cf-b237-477e-a108-ab1ab7cc0b32#t=0.1",
  "https://firebasestorage.googleapis.com/v0/b/peacock-design-eng.firebasestorage.app/o/videos%2FCan't%20Miss%20Clips%20and%20Highlights%2FClips%2Fdefault-2.mp4?alt=media&token=9c82416a-9e2c-4177-8834-7acce390e713#t=0.1",
];

const DEFAULT_COPY = [
  ["The Truth", "Is Revealed"],
  ["It Is", "Getting Hot"],
  ["Who Will", "Be Next?"],
];

export { CLIPS_INFO, NBA_CLIPS, DEFAULT_CLIPS, DEFAULT_COPY };
